import React from "react";
import { UserSubscriptionLoaderTemplate } from "themes/administration/user/components";

function UserSubscriptionLoader(props) {
    return <UserSubscriptionLoaderTemplate {...props} />;
}

export default UserSubscriptionLoader;
